import React from 'react';

import { ExpenseTravels } from 'models/expense';
import { TravelRequested } from 'models/travelRequested';

import Expenses from './Expenses';
import TravelCard from './Travel';

interface Props {
  travel?: ExpenseTravels;
  travelRequested?: TravelRequested;
  showExpirationTime?: boolean;
  showApprovedTag?: boolean;
  showRejectedTag?: boolean;
  onClick: () => void;
  onTravelCancel: () => void;
  onChangeFlight?: (travel: TravelRequested) => void;
  testId?: string;
}

const CardExpenseTravel = ({
  travel,
  travelRequested,
  showExpirationTime,
  showApprovedTag,
  showRejectedTag,
  onClick,
  onTravelCancel,
  onChangeFlight,
  testId,
}: Props) =>
  travel ? (
    <Expenses travel={travel} onClick={onClick} testId={testId} />
  ) : travelRequested ? (
    <TravelCard
      onClick={onClick}
      onCancel={onTravelCancel}
      onChange={onChangeFlight}
      travel={travelRequested}
      showExpirationTime={showExpirationTime}
      showApprovedTag={showApprovedTag}
      showRejectedTag={showRejectedTag}
      testId={testId}
    />
  ) : null;

export default CardExpenseTravel;
